{
  "metadata": {
    "id": "catppuccin-light",
    "name": "Catppuccin",
    "description": "Портировано из темы «Catppuccin» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "catppuccin.json",
      "project": "catppuccin",
      "url": "https://github.com/catppuccin/catppuccin",
      "upstreamFile": "packages/ui/src/theme/themes/catppuccin.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.9,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.466,
      "paletteMaxS": 0.514,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 29.6,
      "syntaxVsTextMinDeltaE": 7.2,
      "chartsMinDeltaE": 53.0,
      "textSeparationDeltaE": 10.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#5e76fd",
      "hover": "#556ae4",
      "active": "#4d61cf",
      "foreground": "#000000",
      "muted": "#5e76fd80",
      "emphasis": "#5e76fd"
    },
    "surface": {
      "background": "#f5e0dc",
      "foreground": "#262735",
      "muted": "#c5b7bd",
      "mutedForeground": "#3e3b44",
      "elevated": "#ada3ad",
      "elevatedForeground": "#393b4e",
      "raised": "#908a99",
      "raisedForeground": "#232531",
      "overlay": "#f5e0dc33",
      "subtle": "#ddcbcc"
    },
    "interactive": {
      "border": "#888394",
      "borderHover": "#c1b1b7",
      "borderFocus": "#5e76fd",
      "selection": "#4c4f6924",
      "selectionForeground": "#4c4f69",
      "focus": "#5e76fd59",
      "focusRing": "#5e76fd47",
      "cursor": "#4c4f69",
      "hover": "#4c4f6917",
      "active": "#4c4f6924"
    },
    "status": {
      "error": "#c80e36",
      "errorForeground": "#ffffff",
      "errorBackground": "#c80e361a",
      "errorBorder": "#c80e3659",
      "warning": "#8e5a12",
      "warningForeground": "#ffffff",
      "warningBackground": "#8e5a121a",
      "warningBorder": "#8e5a1259",
      "success": "#2e741f",
      "successForeground": "#ffffff",
      "successBackground": "#2e741f1a",
      "successBorder": "#2e741f59",
      "info": "#036b95",
      "infoForeground": "#ffffff",
      "infoBackground": "#036b951a",
      "infoBorder": "#036b9559"
    },
    "pr": {
      "open": "#2e741f",
      "draft": "#4b4751",
      "blocked": "#8e5a12",
      "merged": "#d20f39",
      "closed": "#c80e36"
    },
    "syntax": {
      "base": {
        "background": "#c5b7bd",
        "foreground": "#4c4f69",
        "comment": "#484a59",
        "keyword": "#5f10c6",
        "string": "#215416",
        "number": "#743b01",
        "function": "#0840af",
        "variable": "#464860",
        "type": "#8e1246",
        "operator": "#0d0c0e"
      },
      "tokens": {
        "commentDoc": "#484a59",
        "stringEscape": "#0d0c0e",
        "keywordImport": "#5f10c6",
        "storageModifier": "#5f10c6",
        "functionCall": "#0840af",
        "method": "#0840af",
        "variableProperty": "#0840af",
        "variableOther": "#464860",
        "variableGlobal": "#743b01",
        "variableLocal": "#0d0c0e",
        "parameter": "#464860",
        "constant": "#743b01",
        "class": "#8e1246",
        "className": "#8e1246",
        "interface": "#8e1246",
        "struct": "#8e1246",
        "enum": "#8e1246",
        "typeParameter": "#8e1246",
        "namespace": "#8e1246",
        "module": "#5f10c6",
        "tag": "#5f10c6",
        "jsxTag": "#5f10c6",
        "tagAttribute": "#0840af",
        "tagAttributeValue": "#215416",
        "boolean": "#743b01",
        "decorator": "#5f10c6",
        "label": "#0840af",
        "regexp": "#215416"
      }
    },
    "charts": {
      "series": [
        "#5e76fd",
        "#036b95",
        "#2e741f",
        "#8e5a12",
        "#c80e36"
      ]
    },
    "chat": {
      "background": "#f5e0dc",
      "userMessage": "#393b4e",
      "userMessageBackground": "#ada3ad",
      "assistantMessage": "#464860",
      "assistantMessageBackground": "#c5b7bd",
      "timestamp": "#4b4751",
      "divider": "#888394",
      "typing": "#4b4751"
    },
    "loading": {
      "spinner": "#5e76fd",
      "spinnerTrack": "#c5b7bd",
      "skeleton": "#c5b7bd",
      "shimmer": "#beb1b8"
    },
    "tools": {
      "background": "#c5b7bd",
      "border": "#888394",
      "headerHover": "#bfb2b9",
      "icon": "#2c4bfc",
      "title": "#4c4f69",
      "description": "#4b4751",
      "edit": {
        "added": "#2e741f",
        "addedBackground": "#2e741f1a",
        "removed": "#c80e36",
        "removedBackground": "#c80e361a",
        "modified": "#036b95",
        "modifiedBackground": "#036b951a",
        "lineNumber": "#4b4751"
      }
    },
    "markdown": {
      "heading1": "#4c4f69",
      "heading2": "#4c4f69",
      "heading3": "#4c4f69",
      "heading4": "#4c4f69",
      "link": "#314ffc",
      "linkHover": "#3f57e1",
      "inlineCode": "#215416",
      "inlineCodeBackground": "#c5b7bd",
      "blockquote": "#4b4751",
      "blockquoteBorder": "#888394",
      "listMarker": "#5972fd",
      "bold": "#4c4f69",
      "italic": "#4c4f69e6",
      "strikethrough": "#4b4751",
      "hr": "#888394"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b9555a",
        "foreground": "#ffffff",
        "contrast": 4.66
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d3ad93",
        "foreground": "#000000",
        "contrast": 10.17
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c9ad59",
        "foreground": "#000000",
        "contrast": 9.61
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b4cb5d",
        "foreground": "#000000",
        "contrast": 11.64
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b0d697",
        "foreground": "#000000",
        "contrast": 12.91
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#71c959",
        "foreground": "#000000",
        "contrast": 10.2
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#5dc986",
        "foreground": "#000000",
        "contrast": 10.16
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#97d5c1",
        "foreground": "#000000",
        "contrast": 12.6
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#59b6c7",
        "foreground": "#000000",
        "contrast": 8.94
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4f89c2",
        "foreground": "#000000",
        "contrast": 5.69
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4553bd",
        "foreground": "#ffffff",
        "contrast": 6.51
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#8a79c5",
        "foreground": "#000000",
        "contrast": 5.62
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#944ec0",
        "foreground": "#ffffff",
        "contrast": 5.11
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d077cb",
        "foreground": "#000000",
        "contrast": 7.18
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d292b8",
        "foreground": "#000000",
        "contrast": 8.54
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c35087",
        "foreground": "#000000",
        "contrast": 4.82
      }
    ]
  }
}
